module.exports = __webpack_public_path__ + "assets/img/m13.28d59f3f.png";